import store from '~/store'
import router from '~/routes'
import _ from 'underscore'
import config from '~/config'

// function getServerPath() {
//     let server_path = window.location.protocol + '//' + window.location.hostname;
//     if(window.location.port){
//         server_path += ':' + window.location.port;
//     }
//     return server_path;
// }
//
// function getUrlWithLocale(url, absolute_path) {
//     return (absolute_path?getServerPath():"") + '/' + store.state.lang + '/' + url;
// }
//
// function processUrl (url, absolute_path = true) {
//     return getUrlWithLocale(url, absolute_path);
// }

export const UrlServices = {
    createUrl(location, with_server_domain = true) {
        let resolved_route = this.getRouteObject(location);

        if(resolved_route){
            let url = (process.env.NODE_ENV === 'development' && with_server_domain ? config.server_domain : "") + resolved_route.href;
            return this.rewriteUrl(url);
        } else {
            return "";
        }
    },
    createAbsoluteUrl(location) {
        let a = document.createElement('a');
        a.href = this.createUrl(location, false);
        return a.href;
    },
    getRouteObject(location) {
        let resolved_route;
        if(typeof location === "string" ){
            resolved_route = router.resolve(location);
        } else if(typeof location === "object"){
            resolved_route = router.resolve(_.extend(location, {'params': {'lang': store.state.lang}}));
        }
        return resolved_route;
    },
    rewriteUrl(url) {
        return url.replace(/\/?$/, '/');
    }
}